(function () {
  const instances = new WeakMap();
  const mqlList = new WeakMap();
  const MOBILE_QUERY = '(max-width: 749px)';

  function createSplide(el) {
    if (typeof Splide === 'undefined') return null;
    const splide = new Splide(el, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false,
      speed: 400,
      drag: true,
    });
    splide.mount();
    return splide;
  }

  function syncToViewport(el) {
    const mql = window.matchMedia(MOBILE_QUERY);
    const existing = instances.get(el);

    if (mql.matches && !existing) {
      const s = createSplide(el);
      if (s) instances.set(el, s);
    } else if (!mql.matches && existing) {
      existing.destroy();
      instances.delete(el);
    }
  }

  function initEl(el) {
    if (!el) return;
    syncToViewport(el);
    if (mqlList.has(el)) return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = () => syncToViewport(el);
    mql.addEventListener('change', handler);
    mqlList.set(el, { mql, handler });
  }

  function destroyEl(el) {
    if (!el) return;
    const s = instances.get(el);
    if (s) {
      s.destroy();
      instances.delete(el);
    }
    const entry = mqlList.get(el);
    if (entry) {
      entry.mql.removeEventListener('change', entry.handler);
      mqlList.delete(el);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-fatbike-values]').forEach(initEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fatbike-values]').forEach(destroyEl);
  });
})();
